module.exports = __webpack_public_path__ + "static/media/maf-04.fad0a3b7.png";